import { isProduction } from '../environment';

import ReactGA from 'react-ga';

const GA_TRACKING_ID = 'UA-166090821-3'; // YOUR_OWN_TRACKING_ID
ReactGA.initialize(GA_TRACKING_ID);

export const trackPageView = ({
  path,
  trackerNames,
  title,
}: {
  path: string;
  trackerNames?: ReactGA.TrackerNames;
  title?: string;
}) => {
  if (isProduction()) {
    ReactGA.pageview(path, trackerNames, title);
  }
};

export const trackEvent = ({
  args,
  trackerNames,
}: {
  args: ReactGA.EventArgs;
  trackerNames?: ReactGA.TrackerNames;
}) => {
  if (isProduction()) {
    ReactGA.event(args, trackerNames);
  }
};

export const trackException = ({
  errorMessage,
  fatal,
  trackerNames,
}: {
  errorMessage: string;
  fatal?: boolean;
  trackerNames?: ReactGA.TrackerNames;
}) => {
  if (isProduction()) {
    ReactGA.exception({ errorMessage, fatal }, trackerNames);
  }
};
